module.exports = __webpack_public_path__ + "ye.svg?80d42db316e1c6dc5688926c94e3f2b7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ye.svg
// module id = 978
// module chunks = 27